module.exports = __webpack_public_path__ + "static/media/ADANIENT.e00a4198.txt";